import React from 'react';
import { Container, Tabs } from '@mantine/core';
import { GalleryUploader } from '../../../../components/admin/GalleryUploader';
import { useAppSelector } from '../../../../store/hooks';

export const HeaderPage: React.FC = () => {
  const { token } = useAppSelector((state) => state.auth);

  // Set token for gallery service
  React.useEffect(() => {
    if (token) {
      // You'll need to set this in your gallery service
      // galleryService.setToken(token);
    }
  }, [token]);

  return (
    <Container size="xl">
      <Tabs defaultValue="logo">
        <Tabs.List>
          <Tabs.Tab value="logo">Logo</Tabs.Tab>
          <Tabs.Tab value="banners">Banners</Tabs.Tab>
          <Tabs.Tab value="icons">Icons</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="logo" pt="xl">
          <GalleryUploader
            galleryName="HEADER"
            title="Company Logo"
            description="Upload and manage your company logo. The logo will appear in the header of your website."
            itemType="LOGO"
            multiple={false}
          />
        </Tabs.Panel>

        <Tabs.Panel value="banners" pt="xl">
          <GalleryUploader
            galleryName="HEADER"
            title="Header Banners"
            description="Upload promotional banners that appear in the header section."
            itemType="BANNER"
          />
        </Tabs.Panel>

        <Tabs.Panel value="icons" pt="xl">
          <GalleryUploader
            galleryName="HEADER"
            title="Header Icons"
            description="Upload icons for navigation, social media, and other header elements."
            itemType="ICON"
          />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};